module.exports = __webpack_public_path__ + "img/logo_consorcio.png_color.73337f17.png";